export default "__VITE_ASSET__DENTLouU__"